<div>
    <div class="paginator-container">
        <span class="no-mobile">Results per page</span>
        <select class="no-mobile" name="pagesizes" [(ngModel)]="currentPageSize" id="current-page-size" (ngModelChange)="onPageSizeChange($event);">
            <option *ngFor='let p of pageSizes' [value]="p" id="{{p+1}}">{{p}}</option>
        </select>
        <div class="fright">
            <a *ngIf='(currentPage > 1 && totalPages.length > 1)' (click)='onPaginationChange(1)' id="first">&lt;&lt; First</a>
            <a *ngIf='currentPage > 1' (click)='onPaginationChange(currentPage - 1)' id="prev">&lt; Prev</a>
            Page
            <select name="pagenumbers" [(ngModel)]="currentPage" id="current-page" (ngModelChange)="onPaginationChange($event);">
                <option *ngFor='let p of totalPages' [value]="p" id="{{p+1}}">{{p}}</option>
            </select>
            of {{totalPages.length}}
            <a *ngIf='currentPage < totalPages.length' (click)='onPaginationChange(currentPage + 1)' id="next">Next &gt;</a>
            <a *ngIf='currentPage < totalPages.length' (click)='onPaginationChange(totalPages.length)' id="last">Last &gt;&gt;</a>
        </div>
    </div>
</div>